module.exports = __webpack_public_path__ + "img/user.dda03c61.jpg";